import { useMetrics } from '@/hooks/useMetrics';
import { useConfig } from '@/hooks/useConfig';
import { TYPOGRAPHY } from '@/pages/ListContentPage/constants';
import { getCardSx } from '@/theme/utils';
import { Box, useTheme } from '@mui/material';
import { GraduationCap, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const PensumsSection = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();
  const config = useConfig();
  const metrics = useMetrics();

  const handleClick = () => {
    navigate('/pensums');
    metrics.track({
      action: 'click',
      extra_data: { button: 'navite-to-pensum', path: '/pensums' },
    });
    metrics.trackEvent({
      action: 'shortcut_clicked',
      section: 'home',
      companies: config.slug_name ? [config.slug_name] : undefined,
      extra_data: { destination: 'pensums' },
    });
  };

  return (
    <Box
      component="section"
      onClick={handleClick}
      sx={{
        ...getCardSx(theme),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, md: 1.75 },
        padding: { xs: '11px 14px', md: '18px' },
        '&:hover': {
          boxShadow:
            '0 8px 24px -4px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)',
          transform: 'translateY(-2px)',
          borderColor: `${theme.palette.primary.main}30`,
        },
      }}
    >
      {/* Icon box */}
      <Box
        sx={{
          width: { xs: 44, md: 48 },
          height: { xs: 44, md: 48 },
          borderRadius: { xs: '10px', md: '12px' },
          backgroundColor: `${theme.palette.primary.main}14`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <GraduationCap size={22} color={theme.palette.primary.main} />
      </Box>

      {/* Text */}
      <Box flex={1} minWidth={0}>
        <Box
          sx={{
            fontSize: { xs: '14px', md: '15px' },
            fontFamily: TYPOGRAPHY.bold,
            fontWeight: 700,
            color: '#1F1333',
            lineHeight: 1.3,
          }}
        >
          {t('homeScreen.pensums')}
        </Box>
        <Box
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: '#8C8494',
            fontFamily: TYPOGRAPHY.regular,
            lineHeight: 1.3,
            mt: 0.25,
          }}
        >
          {t('homeScreen.activePensumPlan')}
        </Box>
      </Box>

      <ChevronRight size={18} color="#8C8494" />
    </Box>
  );
};
